<template>
  <nav class="c-pagination t-pagination" v-if="pagination.pages !== null">

    <button class="c-pagination__button c-pagination__button--previous t-pagination__button"
      @click="pagingCallback(pagination.previous)"
      v-bind:disabled="pagination.previous === null">
      <i class="fa fa-chevron-left"></i>
    </button>

    <div class="c-pagination__numbers">
      <a class="c-pagination__numbers__number t-pagination__number"
        v-for="page in pagination.pages"
        v-if="page != '...'"
        v-bind:class="{'is-active': page === pagination.current}"
        @click="pagingCallback(page)">
        <span class="c-pagination__numbers__number__box t-pagination__number__box">{{ page }}</span>
      </a>
      <span class="c-pagination__numbers__filler" v-else>{{ page }}</span>
    </div>

    <button class="c-pagination__button c-pagination__button--next t-pagination__button"
      @click="pagingCallback(pagination.next)"
      v-bind:disabled="pagination.next === null">
      <i class="fa fa-chevron-right"></i>
    </button>

  </nav>
</template>



<script>

export default {
  props: {
    pagination: {
      type: Object,
      required: true
    },
    pagingCallback: {
      type: Function,
      required: true
    }
  }
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// Paginate.vue?53f2f10b